import {
  Collapse,
  Flex,
  Group,
  Stack,
  Highlight,
  AspectRatio,
  Box,
} from "@mantine/core";
import {
  Spotlight as MantineSpotlight,
  SpotlightActionData,
} from "@mantine/spotlight";

import { useState } from "react";

interface SpotlightActionProps {
  item: SpotlightActionData & {
    videoUrl: string;
    videoTitle: string;
  };
  query: string;
  expandedId: string | null;
  setExpandedId: (id: string | null) => void;
}
const SpotlightAction = ({
  item,
  query,
  expandedId,
  setExpandedId,
}: SpotlightActionProps) => {
  return (
    <MantineSpotlight.Action
      id={item.id}
      onClick={() => {
        setExpandedId(expandedId === item.id ? null : item.id);
      }}
    >
      <Flex direction="column" gap="sm" w="100%">
        <Group wrap="nowrap">
          <Box w={24}>{item.leftSection}</Box>
          <Stack gap={0}>
            <Highlight highlight={query}>{item.label}</Highlight>
            <Highlight highlight={query} size="xs">
              {item.description}
            </Highlight>
          </Stack>
        </Group>
        <Collapse in={expandedId === item.id} w="100%">
          <AspectRatio ratio={16 / 9}>
            <iframe
              style={{ width: "100%", height: "100%", borderRadius: "4px" }}
              src={item.videoUrl}
              title={item.videoTitle}
              allowFullScreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            />
          </AspectRatio>
        </Collapse>
      </Flex>
    </MantineSpotlight.Action>
  );
};

export default SpotlightAction;
